import { useEffect, useState } from "react";
import { Box, List, ListItemButton, Typography } from "@mui/material";
import { FaArrowRight } from "react-icons/fa6";
import { Link } from "react-router-dom";
import DefaultLayout from "../../components/layouts/default-layout";
import { getDataFromCmsApi } from "../../api/contentful-service.js";

function GovHubServiceLinks() {
    const [data, setData] = useState({});
    const [linkList, setLinkList] = useState([]);

    useEffect(() => {
        getData();
    }, []);

    const getData = async () => {
        const result = await getDataFromCmsApi("Navigation/Tax Services");
        setData(result);
        setLinkList(result.items);
    };

    return (
        <DefaultLayout title={"Tax Services"}>
            <div className="container">
                <Box sx={{ height: "80vh" }} className="py-4">
                    <Typography variant="h5" className="px-3 px-md-0">
                        {data.name}...
                    </Typography>
                    <List>
                        {linkList.map(item => (
                            <ListItemButton
                                key={item}
                                className="d-flex justify-content-between"
                                divider
                                component={Link}
                                to={item.link}
                                target="">
                                <>
                                    {item.name}

                                    <FaArrowRight />
                                </>
                            </ListItemButton>
                        ))}
                    </List>
                </Box>
            </div>
        </DefaultLayout>
    );
}

export default GovHubServiceLinks;
